module.exports = __webpack_public_path__ + "img/img20.d2993ee7.svg";